export default "__VITE_PUBLIC_ASSET__ff27308b__"